import { createFileRoute } from '@tanstack/react-router'
import { CompanyListPage } from 'pages/app/company-list/CompanyListPage'

export const Route = createFileRoute('/_authenticated/app/foretag/')({
  component: CompanyListPage,
})
